<script>
import Separator from '@/components/Separator'

export default
{
    name: 'settings-menu-item',

    props:
    {
        name: { type: String, required: true },
        path: { type: String, required: true },
        icon: { type: String, required: true },
        separator: { type: Boolean, required: false, default: true },
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class={`settings-menu-item ${this.separator ? 'has-separator' : ''}`} on-click={this.onClicked}>
                <div class='menu-item'>
                    <div class='icon-container'>
                        <inline-svg class='icon' src={this.icon} />
                    </div>
                    <span class='menu-item-name'>{ this.name }</span>
                    <inline-svg class='goto-icon' src={require('@/assets/img/back-thick.svg')} />
                </div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        onClicked (e)
        {
            this.$emit('click', { event: e, component: this })
        }
    },

    components:
    {
        Separator
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.settings-menu-item
{
    &.has-separator
    {
        border-top: 1px solid var(--theme-border-color);
    }

    .menu-item
    {
        display: flex;
        flex-direction: row;
        width: 100%;
        font-weight: bold;
        padding: 20px 0;
        cursor: pointer;

        .OnTablet({
            padding-top: 25px;
            padding-bottom: 25px;
        });

        .OnDesktop({
            padding-top: 3%;
            padding-bottom: 3%;
        });

        > .icon-container
        {
            padding: 5px;
            background: linear-gradient(45deg, #CFCFCF, #f5f5f5);
            border-radius: 6px;
            box-shadow: inset 0px -1px 1px 0px #00000026;
            filter: var(--theme-invert);
            .WidthHeight(16px);

            .icon
            {
                width: 100%;
                height: 100%;
                margin-bottom: 4px;
                fill: white;
                filter: inherit;
            }
        }

        > .menu-item-name
        {
            margin-left: 15px;
            margin-top: auto;
            margin-bottom: auto;
            font-size: 2.3vh;
            font-family: Inter;
            font-weight: 500;
            color: var(--theme-text-color-light);

            .OnLargeMobile({ font-size: 2.1vh; });
            .OnTablet({ font-size: 2vh; });
            .OnDesktop({ font-size: 1.8vh; });
        }

        > .goto-icon
        {
            margin-left: auto;
            transform: rotate(180deg);
            fill: var(--theme-background-text-color-heavy);
            .WidthHeight(14px);
            padding-right: 20px;
            margin-top: auto;
            margin-bottom: auto;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/SettingsMenuItem.vue